/* tslint:disable */
/* eslint-disable */
/**
 * BS BFF(ダイナミックパッケージ/DP補助金申請) API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoApplicationComment,
    JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoApplicationCommentFromJSON,
    JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoApplicationCommentFromJSONTyped,
    JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoApplicationCommentToJSON,
} from './JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoApplicationComment';
import {
    JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoFixedPoint,
    JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoFixedPointFromJSON,
    JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoFixedPointFromJSONTyped,
    JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoFixedPointToJSON,
} from './JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoFixedPoint';
import {
    JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoPointUnit,
    JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoPointUnitFromJSON,
    JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoPointUnitFromJSONTyped,
    JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoPointUnitToJSON,
} from './JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoPointUnit';
import {
    JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoTargetUsers,
    JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoTargetUsersFromJSON,
    JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoTargetUsersFromJSONTyped,
    JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoTargetUsersToJSON,
} from './JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoTargetUsers';

/**
 * 
 * @export
 * @interface JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfo
 */
export interface JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfo {
    /**
     * 
     * @type {boolean}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfo
     */
    selected?: boolean;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfo
     */
    cafeCategoryNo?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfo
     */
    cafeCategoryNm?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfo
     */
    cafeMenuNo?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfo
     */
    cafeMenuBranchNo?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfo
     */
    cafeMenuNm?: string;
    /**
     * 
     * @type {boolean}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfo
     */
    memberAccompany?: boolean;
    /**
     * 
     * @type {JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoTargetUsers}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfo
     */
    targetUsers?: JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoTargetUsers;
    /**
     * 
     * @type {JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoPointUnit}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfo
     */
    pointUnit?: JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoPointUnit;
    /**
     * 
     * @type {JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoFixedPoint}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfo
     */
    fixedPoint?: JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoFixedPoint;
    /**
     * 
     * @type {boolean}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfo
     */
    userCount?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfo
     */
    dayCount?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfo
     */
    proxyApp?: boolean;
    /**
     * 
     * @type {JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoApplicationComment}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfo
     */
    applicationComment?: JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoApplicationComment;
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfo
     */
    availablePoint?: number;
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfo
     */
    pointRate?: number;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfo
     */
    rounding?: string;
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfo
     */
    upperLimitPoint?: number;
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfo
     */
    upperLimitAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfo
     */
    cafeSubscriptionId?: string;
}

export function JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoFromJSON(json: any): JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfo {
    return JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoFromJSONTyped(json, false);
}

export function JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'selected': !exists(json, 'selected') ? undefined : json['selected'],
        'cafeCategoryNo': !exists(json, 'cafeCategoryNo') ? undefined : json['cafeCategoryNo'],
        'cafeCategoryNm': !exists(json, 'cafeCategoryNm') ? undefined : json['cafeCategoryNm'],
        'cafeMenuNo': !exists(json, 'cafeMenuNo') ? undefined : json['cafeMenuNo'],
        'cafeMenuBranchNo': !exists(json, 'cafeMenuBranchNo') ? undefined : json['cafeMenuBranchNo'],
        'cafeMenuNm': !exists(json, 'cafeMenuNm') ? undefined : json['cafeMenuNm'],
        'memberAccompany': !exists(json, 'memberAccompany') ? undefined : json['memberAccompany'],
        'targetUsers': !exists(json, 'targetUsers') ? undefined : JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoTargetUsersFromJSON(json['targetUsers']),
        'pointUnit': !exists(json, 'pointUnit') ? undefined : JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoPointUnitFromJSON(json['pointUnit']),
        'fixedPoint': !exists(json, 'fixedPoint') ? undefined : JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoFixedPointFromJSON(json['fixedPoint']),
        'userCount': !exists(json, 'userCount') ? undefined : json['userCount'],
        'dayCount': !exists(json, 'dayCount') ? undefined : json['dayCount'],
        'proxyApp': !exists(json, 'proxyApp') ? undefined : json['proxyApp'],
        'applicationComment': !exists(json, 'applicationComment') ? undefined : JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoApplicationCommentFromJSON(json['applicationComment']),
        'availablePoint': !exists(json, 'availablePoint') ? undefined : json['availablePoint'],
        'pointRate': !exists(json, 'pointRate') ? undefined : json['pointRate'],
        'rounding': !exists(json, 'rounding') ? undefined : json['rounding'],
        'upperLimitPoint': !exists(json, 'upperLimitPoint') ? undefined : json['upperLimitPoint'],
        'upperLimitAmount': !exists(json, 'upperLimitAmount') ? undefined : json['upperLimitAmount'],
        'cafeSubscriptionId': !exists(json, 'cafeSubscription_id') ? undefined : json['cafeSubscription_id'],
    };
}

export function JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoToJSON(value?: JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'selected': value.selected,
        'cafeCategoryNo': value.cafeCategoryNo,
        'cafeCategoryNm': value.cafeCategoryNm,
        'cafeMenuNo': value.cafeMenuNo,
        'cafeMenuBranchNo': value.cafeMenuBranchNo,
        'cafeMenuNm': value.cafeMenuNm,
        'memberAccompany': value.memberAccompany,
        'targetUsers': JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoTargetUsersToJSON(value.targetUsers),
        'pointUnit': JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoPointUnitToJSON(value.pointUnit),
        'fixedPoint': JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoFixedPointToJSON(value.fixedPoint),
        'userCount': value.userCount,
        'dayCount': value.dayCount,
        'proxyApp': value.proxyApp,
        'applicationComment': JpCoBenefitoneBsdpBffPresentationResponseCafeGetResponseCafeMenuInfoApplicationCommentToJSON(value.applicationComment),
        'availablePoint': value.availablePoint,
        'pointRate': value.pointRate,
        'rounding': value.rounding,
        'upperLimitPoint': value.upperLimitPoint,
        'upperLimitAmount': value.upperLimitAmount,
        'cafeSubscription_id': value.cafeSubscriptionId,
    };
}

